import Spinner from 'components/spinner/spinner.component';
import {
  ContentBody,
  ContentContainer,
  ContentHeader,
} from 'pages/giftcard/giftcard.styles';
import { useSelector } from 'react-redux';
import { selectIsLoggedIn } from 'redux/user/user.selectors';
import LoggedInBody from '../logged-in-body/logged-in-body.component';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import AnonBody from '../anon-body/anon-body.component';

const GiftcardViewWrapper = ({ children, isLoading, giftcard }) => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector(selectIsLoggedIn);

  return (
    <>
      {isLoading && <Spinner />}
      <ContentContainer
        elevation={2}
        data-testid={'GiftcardViewPage.ContentContainer'}
      >
        <ContentHeader component="h1" variant="h5">
          {t('eGiftCard.view.header')}
        </ContentHeader>
        <ContentBody>
          {!!giftcard?.cardIdentifier ? (
            <>
              {children}
              {isLoggedIn ? <LoggedInBody giftcard={giftcard} /> : <AnonBody />}
            </>
          ) : !isLoading ? (
            <Typography variant="h5" component="p">
              {t('eGiftCard.cardNotFound')}
            </Typography>
          ) : null}
        </ContentBody>
      </ContentContainer>
    </>
  );
};

export default GiftcardViewWrapper;
